import React from 'react'

export default function ViewEvaluation({ employeeEvaluation, total, title }) {
    return (
        <div className="col-md-6 px-0 border-end">
            <h5 className="border border-end-0 border-start-0 tt-bold font-15 ps-4 py-4 mb-0 border-top-0">
                {title}
            </h5>
            <div className="row ps-3 m-0 pt-3">
                <div className="col-md-8">
                    <h6 className="font-12 bold-text pb-0">Attitude</h6>
                </div>
                <div className="col-md-2 text-center">
                    <h6 className="font-12 bold-text text-blue">Rating
                        <span>
                            <img src="/Images/help.svg" className='ms-1' title="Ratings based on the total 
                    1. Does not Meet Expectations
                    2. Below Expectations
                    3. Meets Expectations
                    4. Sometimes Exceeding Expectations
                    5. Always Exceeding Expectation" alt="help-icon" />
                        </span>
                    </h6>
                </div>
                <div className="col-md-2 text-center">
                    <h6 className="font-12 bold-text text-blue text-blue">Total</h6>
                </div>
            </div>
            {employeeEvaluation.length > 0 ?
                employeeEvaluation.map(eva => {
                    return (
                        <div className="row ps-3 m-0 pt-3">
                            <div className="col-md-8 align-self-center">
                                {eva.heading_name !== 'Attitude' ? <> <h6 className="font-12 bold-text">{eva.heading_name}</h6> </> : null}
                                <p className="font-12 medium-text text-break text-wrap table-inlinetext-clr">
                                    {eva.description}
                                </p>
                            </div>
                            <div className="col-md-2 text-center align-self-center">
                                <p className="font-14 bold-text text-blue">
                                    {eva.headingrating} * <span>{eva.rating}</span>
                                </p>
                            </div>
                            <div className="col-md-2 text-center align-self-center">
                                <p className="font-14 bold-text text-blue">{eva.total}</p>
                            </div>
                        </div>
                    )
                })
                : null
            }
            <div className="row ps-3 m-0 pt-3">
                <div className="col-md-10 text-end align-self-center">
                    <p className="font-14 bold-text text-blue pe-4">Total</p>
                </div>
                <div className="col-md-2 text-center align-self-center">
                    <p className="font-14 bold-text text-blue ">{total?.grand_total}</p>
                </div>
            </div>
            <div className="row ps-3 m-0 pt-3">
                <div className="col-md-10 text-end">
                    <p className="font-14 bold-text text-blue align-self-center pe-4">
                        Rating based on evaluation{' '}
                        <span>

                            <img src="/Images/help.svg" title="
                    Ratings based on the total 
                    44-50 = A+
                    37-43 = A-
                    30-36 = B+
                    24-30 = B-
                    17-23 = C+
                    10-16 = C-"
                                alt="help-icon" />
                        </span>
                    </p>
                </div>
                <div className="col-md-2 text-center px-2">
                    <>
                        <p className="card-text tt-bold font-18 text-skyblue">
                            {total?.grand_rating ? <img
                                src={
                                    !total?.grand_rating
                                        ? null : total?.grand_rating.includes('+') ? `/Images/${total?.grand_rating?.slice(0, -1)}_plus.png`
                                            : total?.grand_rating.includes('-') ? `/Images/${total?.grand_rating?.slice(0, -1)}_minus.png` : null
                                }
                                className="emoji-sty  me-2"
                                alt="excited-emoji"
                            ></img> : null}
                            {total?.grand_rating}
                        </p>
                    </>
                </div>
            </div>
        </div>
    )
}
